import { useEffect } from 'react'
import { observer, inject } from 'mobx-react'

import ViewPension from './ViewPension'
import EditPensionMarried from './EditPensionMarried'
import EditPensionSingle from './EditPensionSingle'

function PensionDashboard(props) {
  const {
    handleCancel,
    store: {
      getSurvivorPensionOptions,
      pensionOptions,
      person: { includeSpouse },
    },
  } = props

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getSurvivorPensionOptions()
      } catch (err) {
        console.error(err)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (Object.keys(pensionOptions).length < 2) {
    return <ViewPension handleCancel={handleCancel} />
  }

  if (!includeSpouse) {
    return <EditPensionSingle handleCancel={handleCancel} />
  }

  return <EditPensionMarried handleCancel={handleCancel} />
}

export default inject('store')(observer(PensionDashboard))
